import type { ReactNode } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

import { noop } from '../../../tailwind-ui';

interface PresentationContextType {
  showPresentation: boolean;
  setShowPresentation: (showPresentation: boolean) => void;
}

// eslint-disable-next-line react-refresh/only-export-components
export const PresentationContext = createContext<PresentationContextType>({
  showPresentation: false,
  setShowPresentation: noop,
});

interface PresentationContextProviderProps {
  children: ReactNode;
}

export function PresentationContextProvider(
  props: PresentationContextProviderProps,
) {
  const { children } = props;
  const [showPresentation, setShowPresentation] = useState(false);

  const context = useMemo<PresentationContextType>(() => {
    return {
      showPresentation,
      setShowPresentation,
    };
  }, [showPresentation]);

  return (
    <PresentationContext.Provider value={context}>
      {children}
    </PresentationContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function usePresentationContext() {
  return useContext(PresentationContext);
}
